module.exports = __webpack_public_path__ + "img/Treesdotcom-horizontal-white.06afa60b.png";